import { render, staticRenderFns } from "./RrcvE_Total.vue?vue&type=template&id=06f815ea"
import script from "./RrcvE_Total.vue?vue&type=script&lang=js"
export * from "./RrcvE_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports